import React, {useEffect, useRef, useState} from 'react';

import {AddonPanel, Button, H2} from '@storybook/components';
import {addons} from '@storybook/manager-api';
import {styled} from '@storybook/theming';

import IssueList from './IssueList';
import NewIssue from './NewIssue';

interface ComponentProps {
    active: boolean;
}

interface StoryEvent {
    storyId: string;
    viewMode: 'docs' | 'story';
}

/**
 * Panel.
 *
 * @param props        Component props.
 * @param props.active Whether the panel is active.
 * @param props.key    The key.
 * @returns The component.
 */
const Panel = ({active}: ComponentProps) => {
    const [storyId, setStoryId] = useState<string | null>(null);
    const [updated, setUpdated] = useState<number>(Date.now());
    const Modal = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        /**
         * Get story id.
         *
         * @param story The story.
         */
        const getStoryId = (story: StoryEvent) => {
            if (story.viewMode === 'story') {
                setStoryId(story.storyId);
            }
        };

        addons.getChannel().on('currentStoryWasSet', getStoryId);

        return () => {
            addons.getChannel().off('currentStoryWasSet', getStoryId);
        };
    }, []);


    return (
        <AddonPanel active={active}>
            <PaddingWrapper>
                <StickyH2>
                    <FlexWrap>
                        GitHub Issues
                        <Button primary onClick={() => Modal.current?.showModal()}>
                            Create Issue
                        </Button>
                    </FlexWrap>
                </StickyH2>
                <IssueList active={active} setUpdated={setUpdated} storyId={storyId!} updated={updated} />
                <NewIssue forwardedRef={Modal} setUpdated={setUpdated} storyId={storyId} />
            </PaddingWrapper>
        </AddonPanel>
    );
};

Panel.displayName = 'Panel';
Panel.defaultProps = {active: false};

export default Panel;

const PaddingWrapper = styled.div`
    padding: 0 10px 10px;
`;

const StickyH2 = styled(H2)`
    background-color: #1B1C1D;
    padding-top: 10px !important;
    position: sticky;
    top: 0;
    z-index: 1;
`;

const FlexWrap = styled.span`
    display: flex;
    justify-content: space-between;
`;